/**
 * Named pages that are used in the event spec.
 * Defined here: https://artprocessors.atlassian.net/wiki/spaces/DAI/pages/2098823270/Empower+-+Event+Specifications+-+Visitor+Analytics
 */
export enum PageEventType {
  /** The first landing page */
  LANDING = 'Landing',
  /** The start listening button has been clicked and the user is listening */
  LISTENING = 'Listening',
  /** The sound has been turned off on the listening page */
  LISTENING_SOUND_OFF = 'Listening - Sound Off',
  /** Info page, by clicking the info button */
  INFO = 'Info',
  /** The transcript page */
  TRANSCRIPT = 'Transcript',
  /** Error */
  ERROR = 'Error',
  /** Not Found */
  NOT_FOUND = 'Not Found',
  /** */
  SYNC_ERROR = 'Sync Error',
}

/*
 * The type of `track` event.
 *
 * Properties change based on track event.
 */
export enum TrackEventType {
  MEDIA_PLAYED = 'Media Played',
  ENTITY_ACTION = 'Entity Action',

  /** Visitor Events */
  START_LISTENING_BUTTON_CLICKED = 'Start Listening Button Clicked',
  PLAY_BUTTON_CLICKED = 'Play Button Clicked',
  MUTE_BUTTON_CLICKED = 'Mute Button Clicked',
  UNMUTE_BUTTON_CLICKED = 'Unmute Button Clicked',
  AUDIO_STARTED_PLAYBACK = 'Audio Started Playback',
  TRANSCRIPT_OPENED = 'Transcript Opened',
  TRANSCRIPT_CLOSED = 'Transcript Closed',
  INFO_MODAL_OPENED = 'Info Modal Opened',
  INFO_MODAL_CLOSED = 'Info Modal Closed',

  /** Callback events */
  PLAY = 'Play',
  PLAY_NEW_TRACK = 'Play New Track',
  PLAY_ERROR = 'Play Error',
  MUTE_TOGGLE = 'Mute Toggle',
  ACTIVE_FINISHED = 'Active Finished',
  ACTIVE_FINISHED_AT_INIT = 'Active Finished At Init',
}
